import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectState } from '../project.state';

const selectProjectState = createFeatureSelector('project');

export const selectProductContext = createSelector(
  selectProjectState,
  (projectState: ProjectState) => projectState.productContextState.context
);
